import React, {useState, useEffect} from 'react';
import BarraRicercaOrdini from './DBperAreaOrdiniComponenti/BarraRicercaOrdini';
import ListaOrdini from './DBperAreaOrdiniComponenti/ListaOrdini';
import BarraFunzioniOrdini from './DBperAreaOrdiniComponenti/BarraFunzioniOrdini';
import stilePulsanti from '../../interfaccia/stilePulsanti.js';


function DBperAreaArticoliOrdini({
    ordine,
    setOrdineFunction,
    urlRicerca,
    setUrlRicerca,
    limiteRighe,
    setLimiteRighe,
    setResImport,
    totalRows,
    setTotalRows,
    perPage,
    setPerPage,
    page,
    setPage,
    urlParametri,
    setUrlParametri,
    datiTendineOrdine,
    ricerca,
    tema,
    utente,
    vista,
    selezioneCampiRicerca,
    inputIniziale,
    setInputIniziale,
    columnSort,
    setColumnSort,
    directionSort,
    setDirectionSort,
    fetchOrdini,
    handlePageChange,
    handlePerRowsChange,
    handleSort,
    setRigheSelezionate,
    righeSelezionate,
    data,
    loading,
    deseleziona,
    setDeseleziona,
    setData,
    setRicerca,
    inputVuoto,
    perPageOptions,
    setVista,
    urlRicercaINIT,
    ricercaIniz,
    mobile,
    setLoading,
    setListeOrdiniDaAltrove,
    setVistaConReset
}) {

    
    /* const { user, getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState("");
    const [listaOrdini, setListaOrdini] = useState([]); */
    const [report, setReport] = useState(false);


    /* useEffect(() => {
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        fetch(urlRicerca, {headers: {Authorization: "Bearer "+token}})
          .then(resp => resp.json())
          .then(data => setListaOrdini(data))
      }, [token]);


    useEffect(() => {
        
        const getUserMetadata = async () => {
     
          try {
            const accessToken = await getAccessTokenSilently();
            setToken(accessToken);
          } catch (e) {
            console.log(e.message);
          }
        };
     
        getUserMetadata();


      }, [getAccessTokenSilently, user?.sub]); */

    //TODO questo blocco l'ho copiato dalla doc del modulo nuovo, integrare token e controllo permessi


    useEffect(() => {
        fetchOrdini(page,urlRicerca);
    }, []);

    const [alertSalvataggio, setAlertSalvataggio] = useState(false);

    return (
        <div class="center">
            <div class="cf contentSubSubHeader ">
                <div class="fl-ns w-100 w-100-ns w-100-m w-100-l pr4 pl3 bb bordoColAlt sfondoColChiaro">
                    {mobile && righeSelezionate.length < 1 && <BarraRicercaOrdini
                        vista={"mobile2"}
                        setListaOrdini={setData}
                        limiteRighe={limiteRighe}
                        setLimiteRighe={setLimiteRighe}
                        righeSelezionate={righeSelezionate}
                        setUrlRicerca={setUrlRicerca}
                        setOrdineFunction={setOrdineFunction}
                        setResImport={setResImport}
                        perPage={perPage}
                        page={page}
                        setTotalRows={setTotalRows}
                        urlParametri={urlParametri}
                        setUrlParametri={setUrlParametri}
                        datiTendineOrdine={datiTendineOrdine}
                        tema={tema}
                        selezioneCampiRicerca={selezioneCampiRicerca}
                        inputIniziale={inputIniziale}
                        setInputIniziale={setInputIniziale}
                        urlRicerca={urlRicerca}
                        setRicerca={setRicerca}
                        columnSort={columnSort}
                        directionSort={directionSort}
                        inputVuoto={inputVuoto}
                        setVista={setVista}
                        urlRicercaINIT={urlRicercaINIT}
                        ricercaIniz={ricercaIniz}
                        setPerPage={setPerPage}
                        mobile={false}
                        setLoading={setLoading}
                        setPage={setPage}
                        setListeOrdiniDaAltrove={setListeOrdiniDaAltrove}
                        setVistaConReset={setVistaConReset}
                        listaOrdini={data}
                        setAlertSalvataggio={setAlertSalvataggio}
                        fetchOrdini={fetchOrdini}
                    />}
                    {righeSelezionate.length < 1 && <BarraRicercaOrdini
                        vista={vista}
                        setListaOrdini={setData}
                        limiteRighe={limiteRighe}
                        setLimiteRighe={setLimiteRighe}
                        righeSelezionate={righeSelezionate}
                        setUrlRicerca={setUrlRicerca}
                        setOrdineFunction={setOrdineFunction}
                        setResImport={setResImport}
                        perPage={perPage}
                        page={page}
                        setTotalRows={setTotalRows}
                        urlParametri={urlParametri}
                        setUrlParametri={setUrlParametri}
                        datiTendineOrdine={datiTendineOrdine}
                        tema={tema}
                        selezioneCampiRicerca={selezioneCampiRicerca}
                        inputIniziale={inputIniziale}
                        setInputIniziale={setInputIniziale}
                        urlRicerca={urlRicerca}
                        setRicerca={setRicerca}
                        ricerca={ricerca}
                        columnSort={columnSort}
                        directionSort={directionSort}
                        inputVuoto={inputVuoto}
                        setVista={setVista}
                        urlRicercaINIT={urlRicercaINIT}
                        ricercaIniz={ricercaIniz}
                        setPerPage={setPerPage}
                        mobile={mobile}
                        setLoading={setLoading}
                        setPage={setPage}
                        setListeOrdiniDaAltrove={setListeOrdiniDaAltrove}
                        setVistaConReset={setVistaConReset}
                        listaOrdini={data}
                        setAlertSalvataggio={setAlertSalvataggio}
                        report={report}
                        setReport={setReport}
                        fetchOrdini={fetchOrdini}
                    />}
                    {righeSelezionate.length > 0 && !mobile && <BarraFunzioniOrdini
                        righeSelezionate={righeSelezionate}
                        page={page}
                        fetchOrdini={fetchOrdini}
                        setRigheSelezionate={setRigheSelezionate}
                        setDeseleziona={setDeseleziona}
                        deseleziona={deseleziona}
                        setRicerca={setRicerca}
                        setVistaConReset={setVistaConReset}
                        datiTendineOrdine={datiTendineOrdine}
                        tema={tema}
                        vista={vista}
                        ricerca={ricerca}
                        urlRicerca={urlRicerca}
                        setUrlRicerca={setUrlRicerca}
                        inputVuoto={inputVuoto}
                        perPage={perPage}
                        setTotalRows={setTotalRows}
                        setListaOrdini={setData} /* controllare questo */
                        setAlertSalvataggio={setAlertSalvataggio}
                    />}
                </div>
                {alertSalvataggio && <div className={stilePulsanti.buttonClassesRed+" pa4 f4"}>{alertSalvataggio}</div>}
                <div class="fl-ns w-100 w-100-ns pr3 pl4 sfondoBiancoTema">
                        <ListaOrdini
                            vista="articoli"
                            setOrdineFunction={setOrdineFunction}
                            listaOrdini={data}
                            setListaOrdini={setData}
                            righeSelezionate={righeSelezionate}
                            setRigheSelezionate={setRigheSelezionate}
                            loading={loading}
                            totalRows={totalRows}
                            handlePerRowsChange={handlePerRowsChange}
                            handlePageChange={handlePageChange}
                            perPage={perPage}
                            deseleziona={deseleziona}
                            utente={utente}
                            handleSort={handleSort}
                            columnSort={columnSort}
                            directionSort={directionSort}
                            ricerca={ricerca}
                            mobile={mobile}
                            page={page}
                            setVistaConReset={setVistaConReset}
                            report={report}
                        />
                    </div>         
            </div>
        </div>

    )
}


export default DBperAreaArticoliOrdini;
